import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const JobPostingCard = ({ job, onEdit, onDuplicate, onViewApplications, onArchive }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'Active':
        return 'bg-success/10 text-success border-success/20';
      case 'Draft':
        return 'bg-warning/10 text-warning border-warning/20';
      case 'Closed':
        return 'bg-muted text-muted-foreground border-border';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-sm transition-shadow duration-150">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="font-semibold text-foreground text-lg mb-2">{job?.title}</h3>
          <div className="flex items-center space-x-4 text-sm text-muted-foreground mb-3">
            <div className="flex items-center space-x-1">
              <Icon name="Building2" size={14} />
              <span>{job?.department}</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="MapPin" size={14} />
              <span>{job?.location}</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="Clock" size={14} />
              <span>{job?.type}</span>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <span className={`px-2 py-1 rounded-full text-xs font-medium border ${getStatusColor(job?.status)}`}>
              {job?.status}
            </span>
            <span className="text-sm text-muted-foreground">
              {job?.applicationCount} applications
            </span>
            <span className="text-sm text-muted-foreground">
              Created {formatDate(job?.createdAt)}
            </span>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between pt-4 border-t border-border">
        <div className="flex items-center space-x-2">
          <Button
            variant="ghost"
            size="sm"
            iconName="Edit"
            iconPosition="left"
            onClick={() => onEdit(job)}
          >
            Edit
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="Copy"
            iconPosition="left"
            onClick={() => onDuplicate(job)}
          >
            Duplicate
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="Users"
            iconPosition="left"
            onClick={() => onViewApplications(job)}
          >
            View Applications
          </Button>
        </div>
        <Button
          variant="ghost"
          size="sm"
          iconName="Archive"
          onClick={() => onArchive(job)}
          className="text-muted-foreground hover:text-error"
        >
          Archive
        </Button>
      </div>
    </div>
  );
};

export default JobPostingCard;